// removed by extract-text-webpack-plugin
module.exports = {"miniProgress":"antd-pro-miniProgress","progressWrap":"antd-pro-progressWrap","progress":"antd-pro-progress","target":"antd-pro-target"};


//////////////////
// WEBPACK FOOTER
// /Applications/MAMP/htdocs/www/alipay-cd/project/antd-pro/antd-pro/scaffold/src/components/Charts/MiniProgress/index.less
// module id = 364
// module chunks = 0 1